import DepsService from 'services/dependencies';

const CONTEXT = 'forgotPassword';

const fetchSecurityQuestionsByUserName = async (username, captchaToken) => {
  const { url } = DepsService.rest.auth.securityQuestions;
  const queryParams = { username, captchaToken };
  const urlParams = {};

  const { questions } = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);

  return questions;
};

const resetPassword = async (data) => {
  const { url } = DepsService.rest.auth.resetPassword;

  return DepsService.restSrv.create(CONTEXT, url, data);
};

function changePassword(newPassword, refreshToken) {
  const { url } = DepsService.rest.auth.changePassword;
  const requestBody = {
    newPassword,
    refreshToken,
  };
  const urlParams = {};

  return DepsService.restSrv.create(CONTEXT, url, requestBody, urlParams);
}

export default {
  resetPassword,
  fetchSecurityQuestionsByUserName,
  changePassword,
};



// WEBPACK FOOTER //
// ./src/modules/auth/resources/forgot-password.api.js